import React from "react";

function CommercialSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15"
      fill="none"
      viewBox="0 0 12 12"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1.476 10.91h9.433M3.048 9.338V5.146m2.096 4.192V5.146M7.24 9.338V5.146m2.097 4.192V5.146m1.048-1.573l-3.97-2.481a.587.587 0 00-.165-.085.262.262 0 00-.116 0c-.043.01-.083.035-.164.085L2 3.573h8.385z"
      ></path>
    </svg>
  );
}

export default CommercialSvg;
